import {CallFunction} from '../../public/bundles/w3comhulk/callFunction.js';
import {createAlert, createIcon, submitPrint} from "./utils_element";
import {getDataLine} from "./utils_dataTables";
import {appRequest} from "./utils_request";
import {disableSubmitButton} from "../../public/bundles/w3comhulk/ajax";
import {createTransportPurchaseOrder} from "./display_gestion_transport";

export const init = () => {
    $('#dataTable').on('draw.dt', (e) => {
        $('button.btn-add-gray-card-fees').off('click');
        $('button.btn-add-gray-card-fees').click(e => {
            addGrayCardFees(e);
        });
        $('button.btn-remove-gray-card-fees').off('click');
        $('button.btn-remove-gray-card-fees').click(e => {
            removeGrayCardFees(e);
        });
        $('button.btn-add-warranty').off('click');
        $('button.btn-add-warranty').click(e => {
            addWarranty(e);
        });
        $('button.btn-remove-warranty').off('click');
        $('button.btn-remove-warranty').click(e => {
            removeWarranty(e);
        });
        $('button.btn-edit-address').off('click');
        $('button.btn-edit-address').click(e => {
            editBillingAddress(e);
        });
    });
};

// BEGIN VH DRAFT FACT - ADD AND REMOVE
const addGrayCardFees = (e) => {
    let dataLine = getDataLine(e),
        data = Object.assign(dataLine.data, {ItemCode: 'FRAIS_CG'}),
        btn = e.currentTarget;
    disableSubmitButton(btn);
    appRequest(urls.addVehicleInvoiceDraft, data)
        .then(resp => {
            if (resp.valid) {
                setRemoveGrayCardFeesState(btn);
            } else {
                alert('System error');
                setAddGrayCardFeesState(btn);
            }
        })
};

const removeGrayCardFees = (e) => {
    let dataLine = getDataLine(e),
        data = Object.assign(dataLine.data, {ItemCode: 'FRAIS_CG'}),
        btn = e.currentTarget;
    disableSubmitButton(btn);
    appRequest(urls.removeVehicleInvoiceDraft, data)
        .then(resp => {
            if (resp.valid) {
                setAddGrayCardFeesState(btn);
            } else {
                alert('System error');
                setRemoveWarrantyState(btn);
            }
        })
};

const setRemoveGrayCardFeesState = (btn) => {
    btn.className = "btn btn btn-danger btn-sm btn-remove-gray-card-fees";
    btn.innerText = "Retirer";
    btn.prepend(createIcon("fal fa-check-square mr-1"));
    $(btn).off('click');
    btn.onclick = (e) => removeGrayCardFees(e);
};

const setAddGrayCardFeesState = (btn) => {
    btn.className = "btn btn btn-primary btn-sm btn-add-gray-card-fees";
    btn.innerText = "Ajouter";
    btn.prepend(createIcon("fal fa-square mr-1"));
    $(btn).off('click');
    btn.onclick = (e) => addGrayCardFees(e);
};

const addWarranty = (e) => {
    let dataLine = getDataLine(e),
        data = Object.assign(dataLine.data, {ItemCode: 'Garantie_12 mois'}),
        btn = e.currentTarget;
    disableSubmitButton(btn);
    appRequest(urls.addVehicleInvoiceDraft, data)
        .then(resp => {
            if (resp.valid) {
                setRemoveWarrantyState(btn)
            } else {
                alert('System error');
                setAddWarrantyState(btn);
            }
        })
};

const removeWarranty = (e) => {
    let dataLine = getDataLine(e),
        data = Object.assign(dataLine.data, {ItemCode: 'Garantie_12 mois'}),
        btn = e.currentTarget;
    disableSubmitButton(btn);
    appRequest(urls.removeVehicleInvoiceDraft, data)
        .then(resp => {
            if (resp.valid) {
                setAddWarrantyState(btn)
            } else {
                setRemoveWarrantyState(btn);
                alert('System error');
            }
        })
};

const setRemoveWarrantyState = (btn) => {
    btn.className = "btn btn btn-danger btn-sm btn-remove-warranty";
    btn.innerText = "Retirer";
    btn.prepend(createIcon("fal fa-check-square mr-1"));
    $(btn).off('click');
    btn.onclick = (e) => removeGrayCardFees(e);
};

const setAddWarrantyState = (btn) => {
    btn.className = "btn btn btn-primary btn-sm btn-add-warranty";
    btn.innerText = "Ajouter";
    btn.prepend(createIcon("fal fa-square mr-1"));
    $(btn).off('click');
    btn.onclick = (e) => addGrayCardFees(e);
};

// END VH DRAFT FACT - ADD AND REMOVE

export const sendInvoiceOnEmail = (rows) => {
    var callFunction = new CallFunction('sendInvoiceOnEmail', 'fad fa-paper-plane fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Envoyer la facture par email.');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    var objWithoutErrors = [];
    rows.map(function (el, index) {
        if (el.U_W3C_EMAI === '') {
            callFunction.addLineResult('VH n°' + el.VH + ' : L\'email du contact n\'est pas renseigné.', 'danger')
        } else if (el.PDFFileName === '') {
            callFunction.addLineResult('VH n°' + el.VH + ' : La facture n\'est pas créée.', 'danger')
        } else if (el.U_W3C_PDFG === 'N') {
            callFunction.addLineResult('VH n°' + el.VH + ' : La facture n\'est pas générée.', 'danger')
        } else {
            objWithoutErrors.push(el);
            callFunction.addLineResult('VH n°' + el.VH + ' : ' + el.U_W3C_EMAI, 'success')
        }
    });

    var param = {
        'sendMailList': objWithoutErrors
    };

    if (objWithoutErrors.length !== 0) {
        callFunction.addValidateBtn(function () {
            callFunction.startLoading();
            $.post(urls.sendInvoice, param, function (rep) {
                window.location.reload();
            }).fail(function () {
                window.location.reload();
            })
        });
    }
};

export const sendQuotation = (rows) => {
    var callFunction = new CallFunction('sendQuotation', 'fad fa-paper-plane fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Envoyer le devis par email.');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    var objWithoutErrors = [];
    rows.map(function (el, index) {
        if (el.U_W3C_EMAI === '') {
            callFunction.addLineResult('VH ' + el.Immatriculation + ' - L\'email du contact n\'est pas renseigné.', 'danger')
        } else {
            objWithoutErrors.push(el);
            callFunction.addLineResult('VH n°' + el.Immatriculation + ' : ' + el.U_W3C_EMAI, 'success')
        }
    });

    var param = {
        'sendMailList': objWithoutErrors
    };

    if (objWithoutErrors.length !== 0) {
        callFunction.addValidateBtn(function () {
            callFunction.startLoading();
            $.post(urls.sendQuotation, param, function (rep) {
                window.location.reload();
            }).fail(function () {
                window.location.reload();
            })
        });
    }
};

const editBillingAddress = (e) => {
    let callFunction = new CallFunction('editBillingAddress', 'fad fa-address-card fa-3x'),
        data = getDataLine(e).data;
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';
    callFunction.showModal('Modification de l\'adresse');
    callFunction.startLoading();
    appRequest(urls.editBillingAddress, {data})
        .then(resp => {
            callFunction.stopLoading();
            if (resp.valid) {
                callFunction.modalBody.innerHTML = resp.template;
                displayFullAddress();
                $('form[name="adjudication_vehicle_billing_address"]').on('keyup', displayFullAddress);
                callFunction.addValidateBtn(() =>
                    submitBillingAddress(data)
                );
            } else {
                let errorMessage = resp.message !== "undefined" ? resp.message : "Une erreur inconnue est survenue";
                callFunction.modalBody.appendChild(createAlert("danger", errorMessage))
            }
        })
};

const submitBillingAddress = (data) => {
    let formData = $('form[name="adjudication_vehicle_billing_address"]').serializeArray(),
        callFunction = new CallFunction('editBillingAddress', 'fad fa-address-card fa-3x');
    callFunction.startLoading();
    appRequest(urls.editBillingAddress, {data, formData})
        .then(resp => {
            callFunction.stopLoading();
            if (resp.valid) {
                callFunction.modalBody.innerHTML = resp.template;
                displayFullAddress();
                $('form[name="adjudication_vehicle_billing_address"]').on('keyup', displayFullAddress);
                callFunction.addValidateBtn(() =>
                    submitBillingAddress(data)
                );
            } else {
                callFunction.addUnknowError();
            }
        })
};

export const displayFullAddress = () => {
    let firstName = document.getElementById('adjudication_vehicle_billing_address_prenomAcheteur'),
        lastName = document.getElementById('adjudication_vehicle_billing_address_nomAcheteur'),
        gender = document.getElementById('adjudication_vehicle_billing_address_titreAcheteur'),
        genderValue = gender.value === "" ? "" : gender.value + ' ',
        coOwner = document.getElementById('adjudication_vehicle_billing_address_coTitulaire'),
        address = document.getElementById('adjudication_vehicle_billing_address_adresse1Acheteur'),
        additionalAddress = document.getElementById('adjudication_vehicle_billing_address_adresse2Acheteur'),
        zipCode = document.getElementById('adjudication_vehicle_billing_address_codePostalAcheteur'),
        city = document.getElementById('adjudication_vehicle_billing_address_villeAcheteur'),
        cardName = document.getElementById('adjudication_vehicle_billing_address_nomEntreprise'),
        country = document.getElementById('adjudication_vehicle_billing_address_paysDeLAcheteur'),
        groupName = document.getElementById('adjudication_vehicle_billing_address_groupName'),
        fullAddress = document.getElementById('adjudication_vehicle_billing_address_fullAddress'),
        coOwnerText = coOwner.value === "" ? String.fromCharCode(13)
            : ' et ' + coOwner.value + String.fromCharCode(13),
        additionalAddressText = additionalAddress.value === "" ? "" : String.fromCharCode(13) + additionalAddress.value;

    if (groupName.value === 'Particulier') {
        fullAddress.value = genderValue + firstName.value + ' ' + lastName.value + coOwnerText + address.value +
            additionalAddressText + String.fromCharCode(13) + zipCode.value + ' ' + city.value +
            String.fromCharCode(13) + country.value;
    } else {
        fullAddress.value = cardName.value + String.fromCharCode(13) +
            genderValue + firstName.value + ' ' + lastName.value + coOwnerText + address.value +
            additionalAddressText + String.fromCharCode(13) + zipCode.value + ' ' + city.value +
            String.fromCharCode(13) + country.value;
    }
};

export const printInvoice = function (data, callFunction) {
    submitPrint(data, callFunction, urls.printInvoice);
};

export const printSticker = function (data, callFunction) {

    callFunction.startLoading();
    $.post(urls.printSticker, {data}, function (rep) {
        callFunction.stopLoading();
        if (rep.status === 500) {
            return callFunction.addUnknowError();
        }
        if (typeof rep.valid !== 'undefined' && rep.valid === true) {
            callFunction.addGlobalSuccess('Impressions en cours...');
            window.location.reload();
        } else {
            callFunction.modalBody.innerHTML = rep.template;
        }
    });
}

export const createCreditNotes = (rows) => {
    var callFunction = new CallFunction('createCreditNotes', 'fas fa-file-contract fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Créer l\'avoir');
    if (!callFunction.checkRowsLength(rows, 1)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    var data = rows.toArray();
    callFunction.addValidateBtn(function () {
        callFunction.startLoading();
        $.ajax({
            data: {data: data},
            type: 'POST',
            url: urls.createCreditNotes,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
                callFunction.addReloadButton();
            },
            complete: function () {
                callFunction.stopLoading();
            }
        });
    });
};

export const toggleVehicleInvoiceDraft = (itemCode, row) => {

};

export const toggleServicePlus = (servicePlusName, row) => {
    //alert('Service : ' + servicePlusName);
    console.log(row);
    console.log(row.XCLE);

    const params = {
        'service': servicePlusName,
        'code': row.XCLE
    };
    $.post("/api/vehicle/service-plus", params, function (data) {
        if (data.valid) {
            window.location.reload();
        } else {
            alert(data.error);
        }
    });
};

export const createInvoice = (rows) => {
    var callFunction = new CallFunction('createInvoice', 'fas fa-file-contract fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Créer la facture');
    if (!callFunction.checkRowsLength(rows, 1)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    var data = rows.toArray();
    callFunction.addValidateBtn(function () {
        callFunction.startLoading();
        $.ajax({
            data: {data: data},
            type: 'POST',
            url: urls.createInvoice,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
                callFunction.addReloadButton();
            },
            complete: function () {
                callFunction.stopLoading();
            }
        });
    });

};

export const runUbiflowAuto = (rows) => {
    var callFunction = new CallFunction('runUbiflowAuto', 'fas fa-file-contract fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Lancer cron');
    if (!callFunction.checkRowsLength(rows, 1)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    var data = rows.toArray();
    callFunction.addValidateBtn(function () {
        callFunction.startLoading();
        $.ajax({
            data: {data: data},
            type: 'POST',
            url: urls.runUbiflowAuto,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
                callFunction.addReloadButton();
            },
            complete: function () {
                callFunction.stopLoading();
            }
        });
    });

};

export const postAdsDisplay = (rows) => {
    var callFunction = new CallFunction('postAdsDisplay', 'fas fa-file-contract fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Envoyer l\'annonce');
    if (!callFunction.checkRowsLength(rows, 1)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    var data = rows.toArray();
    callFunction.addValidateBtn(function () {
        callFunction.startLoading();
        $.ajax({
            data: {data: data},
            type: 'POST',
            url: urls.postAdsDisplay,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
                callFunction.addReloadButton();
            },
            complete: function () {
                callFunction.stopLoading();
            }
        });
    });

};

export const draftAdsDisplay = (rows) => {
    var callFunction = new CallFunction('draftAdsDisplay', 'fas fa-file-contract fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Désactiver l\'annonce');
    if (!callFunction.checkRowsLength(rows, 1)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    var data = rows.toArray();
    callFunction.addValidateBtn(function () {
        callFunction.startLoading();
        $.ajax({
            data: {data: data},
            type: 'POST',
            url: urls.draftAdsDisplay,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
                callFunction.addReloadButton();
            },
            complete: function () {
                callFunction.stopLoading();
            }
        });
    });

};

export const createQuotation = (rows, callFunction) => {
    let site = $('#site-select').val();
    let rowsToJson = JSON.stringify(rows)
    callFunction.startLoading();

    let data = {
        'data': rowsToJson,
        'site': site,
    }

    $.ajax({
        type: 'POST',
        data: data,
        url: urls.createQuotation,
        success: function (response) {
            callFunction.modalBody.innerHTML = '';
            if (response.success) {
                callFunction.addLineResult(response.success, 'success');
            } else if (response.error) {
                callFunction.addLineResult(response.error, 'danger');
            }
            callFunction.stopLoading();
            callFunction.modalFooter.innerHTML = '<button class="btn btn-primary" data-dismiss="modal">Fermer</button>';
        }
    });
};

export const provideQuotation = (rows) => {
    let callFunction = new CallFunction('provideQuotation', 'fad fa-truck');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = ''
    callFunction.showModal('Sélection du site')
    callFunction.startLoading();
    let data = rows.toArray();

    if (data.length === 0) {
        callFunction.modalBody.innerHTML = '<span class="text-danger">Vous devez sélectionner au moins un dossier.</span>';
        callFunction.stopLoading();
        return;
    }

    $.ajax({
        type: 'POST',
        data: data,
        url: urls.provideQuotation,

        success: function (response) {
            callFunction.modalBody.innerHTML = response;
            callFunction.stopLoading();
            callFunction.modalFooter.innerHTML = '<button id="createQuotationValidationButton" class="btn btn-success">Valider</button>'
            $('#createQuotationValidationButton').on('click', function() {
                    createQuotation(data, callFunction);
            })
        }
    })
}

export const printInvoiceOnSiteBySelection = (rows) => {
    var callFunction = new CallFunction('printInvoiceOnSiteBySelection', 'fad fa-address-card fa-3x');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';

    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }

    var listeDV = [];
    rows.map(function (el, index) {
        if (el.DocEntryFact != '') {
            listeDV.push(el.DocEntryFact);
        }
    });

    if (listeDV.length == 0) {
        alert('Vous devez sélectionner au moins un véhicule avec une facture');
        return;
    }
    callFunction.showModal('Impression en cours...');
    callFunction.startLoading();

    $('#printInvoiceOnSiteBySelectionTextLoading').html('Impression en cours...');
    $('#printInvoiceOnSiteBySelection').modal('show');
    $('#printInvoiceOnSiteBySelectionHeader').removeClass('d-none');

    var param = {
        'listDocEntry': listeDV
    };

    $.post(urls.printInvoiceSite, param, function (rep) {
        window.location.reload();
    });
};

export const printInvoiceOnSiteMultiBySelection = (rows) => {
    var callFunction = new CallFunction('printInvoiceOnSiteMultiBySelection', 'fad fa-file-invoice fa-3x');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';

    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }

    var listeDV = [];
    rows.map(function (el, index) {
        if (el.DocEntryFact != '') {
            //listeDV.push(el.DocEntryFact);
            listeDV.push(el);
        }
    });

    if (listeDV.length == 0) {
        alert('Vous devez sélectionner au moins un véhicule avec une facture');
        return;
    }

    callFunction.showModal('Impression en cours...');
    callFunction.modalBody.innerHTML = '<h1 style="text-align: center" id="immatEnCours"></h1>' +
        '<div class="progress">' +
        '<div class="progress-bar bg-success" role="progressbar" style="width: 0%;" aria-valuenow="0" ' +
        'aria-valuemin="0" aria-valuemax="100" id="printInvoiceProgressBar">0%</div>' +
        '</div>';
    printOneInvoice(listeDV,0);
};

export const printOneInvoice = (listDV, currentIndex) => {
    const params = {
        'listDocEntry': [listDV[currentIndex].DocEntryFact]
    }

    $.post(urls.printInvoiceSite,params, function(rep){
        const newIndex = currentIndex + 1;
        //callFunction.modalBody.innerHTML = newIndex + ' / ' + listDocEntry.length;
        const avancement = Math.round((newIndex / listDV.length) * 100);
        document.getElementById('printInvoiceProgressBar').setAttribute('aria-valuenow',avancement.toString());
        document.getElementById('printInvoiceProgressBar').style.width = avancement + '%';
        document.getElementById('printInvoiceProgressBar').innerHTML = avancement + '%';
        document.getElementById('immatEnCours').innerHTML = [listDV[currentIndex].U_W3C_NOIM];
        if(newIndex<listDV.length){
            printOneInvoice(listDV,newIndex);
        } else {
            window.location.reload();
        }
    })
}

export const printInvoiceOnSiteMultiAsyncBySelection = (rows) => {
    var callFunction = new CallFunction('printInvoiceOnSiteMultiAsyncBySelection', 'fad fa-file-invoice fa-3x');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';

    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }

    var listeDV = [];
    rows.map(function (el, index) {
        if (el.DocEntryFact != '') {
            //listeDV.push(el.DocEntryFact);
            listeDV.push(el);
        }
    });

    if (listeDV.length == 0) {
        alert('Vous devez sélectionner au moins un véhicule avec une facture');
        return;
    }

    callFunction.showModal('Impression en cours...');
    callFunction.modalBody.innerHTML = '<h1 style="text-align: center" id="immatEnCours"></h1>' +
        '<div class="progress">' +
        '<div class="progress-bar bg-success" role="progressbar" style="width: 0%;" aria-valuenow="0" ' +
        'aria-valuemin="0" aria-valuemax="100" id="printInvoiceProgressBar">0%</div>' +
        '</div>';
    printOneInvoiceAsync(listeDV,0);
};

export const printOneInvoiceAsync = (listDV, currentIndex) => {
    const params = {
        'listDocEntry': [listDV[currentIndex].DocEntryFact]
    }

    $.post(urls.printInvoiceSiteAsync,params, function(rep){
        const newIndex = currentIndex + 1;
        //callFunction.modalBody.innerHTML = newIndex + ' / ' + listDocEntry.length;
        const avancement = Math.round((newIndex / listDV.length) * 100);
        document.getElementById('printInvoiceProgressBar').setAttribute('aria-valuenow',avancement.toString());
        document.getElementById('printInvoiceProgressBar').style.width = avancement + '%';
        document.getElementById('printInvoiceProgressBar').innerHTML = avancement + '%';
        document.getElementById('immatEnCours').innerHTML = [listDV[currentIndex].U_W3C_NOIM];
        if(newIndex<listDV.length){
            printOneInvoiceAsync(listDV,newIndex);
        } else {
            window.location.reload();
        }
    })
}

export const printInvoiceOnSiteBySelection46 = (obj) => {
    var callFunction = new CallFunction('printInvoiceOnSiteBySelection', 'fad fa-address-card fa-3x');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';

    if (!callFunction.checkRowsLength(obj, 1, callFunction)) {
        return;
    }

    var listeDV = [];
    obj.map(function (el, index) {
        if (el.DocEntryFact != '') {
            listeDV.push(el.DocEntryFact);
        }
    });

    if (listeDV.length == 0) {
        alert('Vous devez sélectionner au moins un véhicule avec une facture');
        return;
    }
    callFunction.showModal('Impression en cours...');
    callFunction.startLoading();

    $('#printInvoiceOnSiteBySelectionTextLoading').html('Impression en cours...');
    $('#printInvoiceOnSiteBySelection').modal('show');
    $('#printInvoiceOnSiteBySelectionHeader').removeClass('d-none');

    var param = {
        'listDocEntry': listeDV
    };

    $.post("/print/invoice-site46", param, function (rep) {
        $('#printInvoiceOnSiteBySelection').modal('hide');
    });
};

export const launchInvoicePrinting = (obj) => {
    var printingSelectedFormat = $('input[data-checkbox-print]:checked');
    var activitiesSelectedFormat = $('input[data-checkbox-activity]:checked');

    if (printingSelectedFormat.length == 0) {
        alert('Vous devez sélectionner au moins un format d\'impression');
        return;
    }
    var listPrint = [];
    printingSelectedFormat.map((index, el) => listPrint.push($(el).val()));

    var listActivity = [];
    activitiesSelectedFormat.map((index, el) => listActivity.push($(el).val()));

    if ($('#printer').val() == '') {
        alert('Vous devez sélectionner une imprimante');
        return;
    }
    var listDocEntry = [];
    lines.map((e) => listDocEntry.push(e[docEntryField]));
    var param = {
        'listDocEntry': listDocEntry.join('|'),
        'listPrintFormat': listPrint.join('|'),
        'selectedPrinter': $('#printer').val(),
        'createActivity': listActivity

    };

    callFunction.startLoading();
    $.post("/print/invoice", param, function (rep) {
        window.location.reload();
    });
};

export const checkInvoicePrinting = (nbPrint) => {
    $.get("/print-check/invoice/" + nbPrint, function (rep) {
        if (rep.hasOwnProperty('valid')) {
            if (rep.valid) {
                var percent = (parseInt(rep.result.done, 10) * 100) / parseInt(rep.result.todo, 10);
                $('#pbInvoicePrinting').css('width', percent + '%');
            }
        }
        setTimeout(function () {
            checkInvoicePrinting(nbPrint);
        }, 1000);
    })
};



// WEBPACK FOOTER //
// ./assets/js/display_facturation.js